// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item[data-v-cdc7777a]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:8px;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.item .icon[data-v-cdc7777a]{width:20px;height:auto}.item .module[data-v-cdc7777a]{font-size:.8em;font-weight:400;color:#4a4a4a}", ""]);
// Exports
module.exports = exports;
